import React from 'react';
import CallIcon from '@material-ui/icons/Call';
import Utils from "../../../helpers/Utils";
import VirtualNumberSelector from "./VirtualNumberSelector";
import {useSelector} from "react-redux";
import {IconButton} from "@material-ui/core";
import {makeName} from "./index";
import ContactListSkeleton from "./ContactListSkeleton";
import PhoneNumber from "./PhoneNumber";

const ContactList = ({ search, initiateCalling, popoverInnerRef2 }) => {
    const {loadingContacts, contacts, callEnvironment} = useSelector((state)=>(state.globalDialerV2));

    return (
        <div className='contactList'>
            {
                loadingContacts ?
                    <ContactListSkeleton/> :
                    <div className='scrollBar'>
                        {
                            contacts[0] ?
                                contacts.map((item, index) => (
                                    <div key={index} className='contactItem'>
                                        <span className='itemTitle'>{makeName(item)}</span>
                                        <span className='leftSide'>
                                            <span className='itemPhone'>
                                                <PhoneNumber number={Utils.formatNumber(item.number)} />
                                            </span>
                                            <IconButton onClick={()=>{
                                                initiateCalling(item, callEnvironment.fromNumber);
                                            }}>
                                                <CallIcon />
                                            </IconButton>
                                        </span>
                                    </div>
                                )) :
                                search.length > 9 && Utils.validateMobileNumber(Utils.cleanPhoneNumber(search)) &&
                                (
                                    <div>
                                        <span className='nonContactMessage'>Not in your contacts</span>
                                        <div className='contactItem'>
                                            <span className='itemTitle'>Unknown</span>
                                            <span className='leftSide'>
                                            <span className='itemPhone'>
                                                <PhoneNumber number={Utils.formatNumber(search)}/>
                                            </span>
                                            <IconButton onClick={()=>{
                                                initiateCalling(null, callEnvironment.fromNumber, search);
                                            }}>
                                        <CallIcon />
                                    </IconButton>
                                </span>
                                        </div>
                                    </div>
                                )
                        }
                    </div>
            }

            <VirtualNumberSelector
                popoverInnerRef2={popoverInnerRef2}
            />
        </div>
    );
};

export default ContactList;